import { render, staticRenderFns } from "./PromotionActive.vue?vue&type=template&id=9c55b816&"
import script from "./PromotionActive.vue?vue&type=script&lang=ts&"
export * from "./PromotionActive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports